function s(o, t, n) {
  for (const [f, i] of Object.entries(n)) {
    const e = o[f];
    e && (e[t] = i);
  }
}
export {
  s as setComponentFields
};
//# sourceMappingURL=utils.js.map
